import { SectionSideContentProps } from '@portfolio/models'
import { PortableText, SectionWrapper } from '@portfolio/components'
import { styled } from '@portfolio/styles'
import { SectionQuote } from '../SectionQuote/SectionQuote'
import { SectionIconWithTextList } from '../SectionIconWithTextList/SectionIconWithTextList'
import { SectionSingleMediaWithDescription } from '../SectionSingleMediaWithDescription/SectionSingleMediaWithDescription'
import { SectionVideoPlayer } from '../SectionVideoPlayer/SectionVideoPlayer'
import { SectionQuoteWithVideo } from '../SectionQuoteWithVideo/SectionQuoteWithVideo'
import { SectionStats } from '../SectionStats/SectionStats'
import { SectionMedia } from '../SectionMedia/SectionMedia'

const SectionSideContentContainer = styled('div', {
  paddingInline: 20,
  margin: '0 auto',
  '@lg': {
    paddingInline: 30,
  },
  '@xxl': {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: 30,
    paddingInline: 30,
  },

  variants: {
    variant: {
      default: {},
      wide: {
        '@lg': {
          display: 'flex',
          justifyContent: 'space-between',
        },

        '@xxl': {
          maxWidth: '$maxWidthDesktop',
          marginInline: 'auto',
        },
      },
    },
  },

  defaultVariants: {
    variant: 'default',
  },
})

const SectionSideContentTitle = styled('h2', {
  marginBottom: 56,
  projectFont: 'heading04',
  color: '$white',

  variants: {
    variant: {
      default: {},
      wide: {
        projectFont: 'heading10',
        marginBottom: 48,
      },
    },
  },
})

const SectionSideContentText = styled('div', {
  color: '$white',

  '@lg': {
    gridColumn: 2,
    width: '85%',
    maxWidth: 1080,
  },

  variants: {
    variant: {
      default: {},
      wide: {
        '@lg': {
          maxWidth: '60%',
        },
        '@xl': {
          display: 'flex',
          justifyContent: 'flex-end',
          maxWidth: '40%',
        },
      },
    },
  },

  defaultVariants: {
    variant: 'default',
  },
})

const SectionTextContent = styled('div', {
  projectFont: 'heading07',
  fontSize: 24,
})

export function SectionSideContent({
  title,
  content,
  variant = 'default',
  spacing,
  topBorder,
}: SectionSideContentProps) {
  return (
    <SectionWrapper type={spacing || 'DEFAULT'} topBorder={topBorder}>
      <SectionSideContentContainer variant={variant}>
        {title && (
          <SectionSideContentTitle variant={variant}>
            {title}
          </SectionSideContentTitle>
        )}
        {content && (
          <SectionSideContentText variant={variant}>
            <PortableText
              value={content}
              disableTopBottomMargins={true}
              additionalComponents={{
                block: {
                  normal: (props) => {
                    return (
                      <SectionTextContent>{props.children}</SectionTextContent>
                    )
                  },
                },
                types: {
                  sectionQuote: (props) => {
                    return <SectionQuote {...props.value} />
                  },
                  sectionIconWithTextList: (props) => {
                    return <SectionIconWithTextList {...props.value} />
                  },
                  sectionSingleMediaWithDescription: (props) => {
                    return (
                      <SectionSingleMediaWithDescription {...props.value} />
                    )
                  },
                  sectionVideoPlayer: (props) => {
                    return <SectionVideoPlayer {...props.value} />
                  },
                  sectionQuoteWithVideo: (props) => {
                    return <SectionQuoteWithVideo {...props.value} />
                  },
                  sectionStats: (props) => {
                    return <SectionStats {...props.value} />
                  },
                  sectionMedia: (props) => {
                    return <SectionMedia {...props.value} />
                  },
                },
              }}
            />
          </SectionSideContentText>
        )}
      </SectionSideContentContainer>
    </SectionWrapper>
  )
}
